<template>
  <b-card>
    <b-card-body>
      <b>1. Aşama</b>
      <div class="card-text description mb-2">
         <span v-if="$store.getters['user/isShopify']">
            Shopify panelinizde <code>theme.liquid</code> dosyasını açın ve <code>&lt;head&gt;</code> etiketleri arasına ekleyin.
         </span>
         <span v-else>
            Kopyaladığınız kodu örnekteki gibi <code>&lt;head&gt; &lt;/head&gt;</code> etiketleri arasına ekleyiniz.
         </span>
      </div>

      <prism language="markup">
          {{ scriptTag }}
      </prism>
      
      <div class="d-flex center mt-2 align-items-center">
        <b-button variant="primary" @click="copyCode(scriptTag)">
        Kopyala
        </b-button>
      </div>
    </b-card-body>
    <div v-if="$store.getters['user/isTsoft']">
        <b-card-body class="mt-2">
          <b>2. Aşama (T-Soft)</b>
          <prism language="markup">
            {{ tsoftCategoryCode }}
          </prism>
          <div class="card-text description">
            Bu kodu T-Soft ürün liste şablonuna ekleyiniz.
          </div>
        </b-card-body>

        <b-card-body class="mt-2">
          <b>3. Aşama (T-Soft)</b>
          <prism language="markup">
            {{ tsoftProductCode }}
          </prism>
          <div class="card-text description">
            Bu kodu T-Soft ürün detay şablonuna ekleyiniz.
          </div>
        </b-card-body>

        <b-card-body class="mt-2">
            <b>4. Aşama</b>
            <div class="card-text description">
              T-soft panelinde dijitall adında web servis oluşturulacak.
            </div>
        </b-card-body>
    </div>

    <div v-if="$store.getters['user/isShopify']">
        <b-card-body class="mt-2">
            <b>2. Aşama (Shopify)</b>
            <div class="card-text description">
                Shopify'a özel kurulum adımları buraya gelecek...
            </div>
        </b-card-body>
    </div>

    <div v-if="$store.getters['user/isTicimax']">
        <b-card-body class="mt-2">
            <b>2. Aşama (Ticimax)</b>
            <div class="card-text description">
                      <prism language="markup">
                {{ scriptTagTicimax }}
            </prism>
            
            <div class="d-flex center mt-2 align-items-center">
              <b-button variant="primary" @click="copyCode(scriptTagTicimax)">
              Kopyala
              </b-button>
            </div>
            </div>
        </b-card-body>
    </div>

  </b-card>
</template>

<script>
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import Prism from 'vue-prism-component'
import { BCard, BButton, BCardBody } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    Prism,
    BButton,
    BCardBody
  },
  data() {
    return {
      // T-Soft statik kodları
      tsoftCategoryCode: `<input type="hidden" id="category-id" value="{$CATEGORY_ID}"/>`,
      tsoftProductCode: '<input type="hidden" id="product-category-ids" value="{$P.CATEGORY_IDS}" />'
    }
  },
  computed: {
    // Sadece scriptTag kaldı, diğerlerini sildik.
    scriptTag() {
        // Not: Burada 'user' modülünün altındaki state'e erişiyoruz
        const secretKey = this.$store.state.user.customerInfo.secret_key;
        let jsFile = 'main.js'; 

        // Script içinde de yine uzun yolu kullanıyoruz:
        if (this.$store.getters['user/isShopify']) {
            jsFile = 'main_shopify.js';
        }else if (this.$store.getters['user/isTicimax']) {
            jsFile = 'main_ticimax.js';
        }

        console.log("this.$store.state.user.customerInfo")
        console.log(this.$store.state.user.customerInfo)


        return `<script src="https://statik.fenomany.com/${jsFile}?customer_sk=${secretKey}"><\/script>`;
    },
    scriptTagTicimax() {
      const secretKey = this.$store.state.user.customerInfo?.secret_key || '';
      const jsFile = 'main_ticimax.js';
      const version = 5;

      return `<script>
  (function() {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://statik.fenomany.com/${jsFile}?v=${version}&customer_sk=${secretKey}';
      script.async = true;
      document.getElementsByTagName('head')[0].appendChild(script);
  })();
  <\/script>`;
    }
  },
  methods: {
    copyCode(textToCopy) {
      navigator.clipboard.writeText(textToCopy).then(() => {
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              icon: 'CopyIcon',
              variant: 'success',
              title: 'Kopyalandı!',
            },
          });
      }).catch(err => {
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              icon: 'InfoIcon',
              variant: 'warning',
              title: 'Hata: ' + err.message,
            },
          });
      });
    }
  }
}
</script>